import React from "react";
import { SkeletonWave } from "app/components/Skeleton";

const Loading = () => {
  return (
    <div className="grid grid-cols-4 gap-3 w-1/4 bg-[#fff]  py-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className=" !p-[10px] h-[30px]  items-center flex flex-row  "
        >
          <SkeletonWave className="h-[20px] w-full rounded-md w-1/2  bg-gray-10  " />
        </div>
      ))}
    </div>
  );
};

export default Loading;
